/**
 * Change-Radar / Änderungszentrale — Ticket-Datenmodell (Firestore: change_requests).
 * Persistenz-Pfad (V1): kalkulation_mandanten/{clientId}/change_requests/{ticketId}
 * (Top-Level bräuchte eigene Rules; Subcollection nutzt bestehende Mandanten-Rechte.)
 */

export type ChangeRequestType = 'change_request' | 'unlock_h2' | 'both';

export type ChangeRequestStatus = 'pending' | 'completed' | 'rejected';

export const CHANGE_REQUESTS_COLLECTION = 'change_requests';

export interface ChangeRequestTicket {
    id?: string;
    clientId: string;
    mandantNr: string;
    firmenname: string;
    betreuer?: string;
    status: ChangeRequestStatus;
    /** Checkbox „2. Halbjahr freischalten“ aus der Änderungszentrale */
    unlock_h2: boolean;
    type: ChangeRequestType;
    message?: string;
    senderName?: string;
    senderEmail?: string;
    coachName?: string;
    coachEmail?: string;
    createdAt?: unknown;
    completedAt?: unknown;
    completedByUid?: string;
    completedByName?: string;
    /** Nur Premium-Buchung / -Kündigung (Change-Radar manuell abhakbar) */
    category?: string;
    toolId?: string;
    toolName?: string;
    title?: string;
}

/** Premium-Kosten-Meldung — kein AZ-Draft, daher manuell im Radar abhakbar. */
export function isPremiumCostRadarTicket(t: {
    category?: string;
    toolId?: string;
}): boolean {
    if (t.category === 'Kosten-Update' || t.category === 'Abo-Kündigung') return true;
    return Boolean(t.toolId);
}

/**
 * type-Auflösung laut Briefing:
 * - unlock_h2 + weitere Änderungen → 'both'
 * - nur Checkbox → 'unlock_h2'
 * - sonst → 'change_request'
 */
export function resolveChangeRequestType(
    unlock_h2: boolean,
    hasOtherChanges: boolean
): ChangeRequestType {
    if (unlock_h2 && hasOtherChanges) return 'both';
    if (unlock_h2) return 'unlock_h2';
    return 'change_request';
}
